module.exports = __webpack_public_path__ + "static/media/ant@2x.7d1704a8.png";